"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YES_CONSENT = exports.NO_CONSENT = exports.COOKIE_EXPIRY_DAYS = exports.COOKIE_CONSENT_NAME = void 0;
exports.classString = classString;
exports.clearCookies = clearCookies;
exports.getCookie = getCookie;
exports.getViewportDimension = getViewportDimension;
exports.isAbsoluteUrl = isAbsoluteUrl;
exports.isInEu = exports.isHTMLDocument = exports.isBrowser = void 0;
exports.setCookie = setCookie;
var _compact2 = _interopRequireDefault(require("lodash/compact"));
function classString(classes) {
  return (0, _compact2.default)(classes).join(' ');
}
const isInEu = () => !!Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone?.startsWith('Europe');

/**
 * Cookie helpers
 **/
exports.isInEu = isInEu;
const COOKIE_CONSENT_NAME = exports.COOKIE_CONSENT_NAME = 'cookieConsent';
const YES_CONSENT = exports.YES_CONSENT = 'yes';
const NO_CONSENT = exports.NO_CONSENT = 'no';
const COOKIE_EXPIRY_DAYS = exports.COOKIE_EXPIRY_DAYS = 180;
function clearCookies(whitelist = []) {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) return null;
  const cookies = document.cookie.split('; ');
  for (let c = 0; c < cookies.length; c++) {
    const d = window.location.hostname.split('.');
    while (d.length > whitelist.length) {
      const cookieName = cookies[c].split(';')[0].split('=')[0];
      if (!whitelist.includes(cookieName)) {
        const cookieBase = encodeURIComponent(cookieName) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        const p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }
  }
}
function setCookie(name, value, days) {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) return null;
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function getCookie(name) {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
const isBrowser = () => typeof window !== 'undefined';
exports.isBrowser = isBrowser;
const isHTMLDocument = () => typeof document !== 'undefined';
exports.isHTMLDocument = isHTMLDocument;
function getViewportDimension(d, fallback = 0) {
  if (typeof window !== 'undefined' && window.document) {
    if (d === 'vw' || d === 'width') {
      return Math.max(document.documentElement.clientWidth || fallback, window.innerWidth || fallback);
    } else if (d === 'vh' || d === 'height') {
      return Math.max(document.documentElement.clientHeight || fallback, window.innerHeight || fallback);
    } else {
      throw Error('Not a valid viewport dimension');
    }
  } else {
    return fallback;
  }
}
function isAbsoluteUrl(url) {
  return /^(?:[a-z+]+:)?\/\//i.test(url);
}